if (!customElements.get('new-product-info')) {
  class NewProductInfo extends HTMLElement {
    abortController = undefined;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];
    atcBar = null;

    constructor() {
      super();
    }

    get currentVariant() {
      return JSON.parse(this.querySelector('script[data-current-variant]').innerHTML);
    }

    get selectedOptionValues() {
      return Array.from(
        this.querySelectorAll('.js-option-button input[type="radio"]:checked, select'),
        (el) => ({
          name: el.getAttribute('name'),
          value: el.value,
          id:
            el.dataset.optionValueId ||
            el.selectedOptions[0]?.dataset.optionValueId ||
            '',
        })
      );
    }

    get currentVariantId() {
      const selectedVariantInput = this.querySelector(
        'input[name="id"][type="hidden"]'
      );
      return selectedVariantInput ? selectedVariantInput.value : null;
    }

    connectedCallback() {
      this.initializeProductSwapUtility();
      this.attachEventListeners();
      // this.postProcessHtmlCallbacks.push(() => {
      //   lipscore.initWidgets();
      // });
      this.atcBar = document.querySelector('sticky-atc');
    }

    /**
     * Initialize product swap utility.
     */
    initializeProductSwapUtility() {
      this.postProcessHtmlCallbacks.push((newNode) => {
        // Change klarna color
        waitForElement('klarna-placement', (el) => {
          const checkShadow = () => {
            const shadow = el.shadowRoot;
            if (!shadow) {
              requestAnimationFrame(checkShadow);
              return;
            }

            const style = document.createElement('style');
            style.textContent = `
              .container {
                background-color: transparent !important;
              }
            `;

            shadow.appendChild(style);
          };

          checkShadow();
        });
      });
    }

    /**
     * Attach event listeners.
     */
    attachEventListeners() {
      this.addEventListener('change', this.onVariantChange);
      this.querySelector('.lipscore-widget-container')?.addEventListener('click', () => {
        document.querySelector('#lipscore-review-list')?.scrollIntoView({ behavior: 'smooth' });
      });
    }

    /**
     * Build request URL with params.
     *
     * @param {String} url
     * @param {Array} optionValues
     * @returns {String}
     */
    buildRequestUrlWithParams(url, optionValues, swapProduct = false) {
      const params = [];

      if (swapProduct && this.dataset.sectionId) {
        params.push(`section_id=${this.dataset.section}`);
      }

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }

      return `${url}?${params.join('&')}`;
    }

    /**
     * Render product info.
     *
     * @param {String} requestUrl
     * @param {Function} callback
     */
    async fetchProductInfo({ requestUrl, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      return fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

          callback(html);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    }

    onVariantChange(event, selectedOptions = this.selectedOptionValues) {
      if (event.target.type === 'number' || event.target.name === 'id') {
        return;
      }

      const productUrl =
        event.target.dataset.productUrl ||
        this.pendingRequestUrl ||
        event.target.selectedOptions?.[0].dataset.productUrl ||
        this.dataset.url;

      this.pendingRequestUrl = productUrl;
      const shouldSwapProduct = this.dataset.url !== productUrl;

      if (shouldSwapProduct) {
        window.location.replace(productUrl);
      } else {
        const selectedOptionsValues = selectedOptions.map((value) => value.id);
        const URLToReplace = this.buildRequestUrlWithParams(
          productUrl,
          selectedOptionsValues,
          false
        );

        this.fetchProductInfo({
          requestUrl: URLToReplace,
          callback: this.handleUpdateProductInfo(),
        });
      }
    }

    /**
     * Handle swap product.
     * @returns {Function}
     */
    handleSwapProduct() {
      return (html) => {
        document.querySelector('head title').innerHTML =
          html.querySelector('head title').innerHTML;

        HTMLUpdateUtility.viewTransition(
          document.querySelector('main'),
          html.querySelector('main'),
          this.preProcessHtmlCallbacks,
          this.postProcessHtmlCallbacks
        );
      };
    }

    /**
     * Handle update product info.
     *
     * @returns {Void}
     */
    handleUpdateProductInfo() {
      return (html) => {
        const replacedIds = [];
        for (const oldElement of document.querySelectorAll('[data-ajax-reload-id]')) {
          if (replacedIds.includes(oldElement.dataset.ajaxReloadId)) {
            continue;
          }

          replacedIds.push(oldElement.dataset.ajaxReloadId);
          const newElement = html.querySelector(`[data-ajax-reload-id="${oldElement.dataset.ajaxReloadId}"]`);

          HTMLUpdateUtility.viewTransition(
            oldElement,
            newElement,
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        }

        if (this.currentVariant) {
          this.updateURL(this.currentVariant.id);
          this.updateBISButton();
        }

        window?.Shopify?.PaymentButton?.init();
      };
    }

    /**
     * Update URL.
     *
     * @returns {Void}
     */
    updateURL(variantId) {
      if (!variantId) return;
      const params = new URLSearchParams(window.location.search);
      params[params.has('variant') ? 'set' : 'append'](
        'variant',
        variantId,
      );
      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?${params.toString()}`,
      );
    }

    /**
     * Update BIS button variant ID and visibility.
     */
    updateBISButton() {
      const currentVariant = this.currentVariant;
      const BISButton = this.querySelector('#BIS_trigger');
      if (currentVariant.available) {
        BISButton.style.display = 'none';
        return;
      }

      BISButton.style.display = 'block';
      BISButton.dataset.variantId = currentVariant.id;
    }
  }
  customElements.define('new-product-info', NewProductInfo);
}
